import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth-context.js";
import type { ReactNode } from "react";

/**
 * Gate for app-shell routes. Redirects unauthenticated users to /sign-in
 * with a `next` query so we can bounce them back after they log in.
 */
export const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-fg-muted">
        Loading…
      </div>
    );
  }
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/sign-in?next=${next}`} replace />;
  }
  return <>{children}</>;
};
